import TheLoader from './TheLoader'

export default TheLoader